import { Box, styled } from "@mui/material"

const StyledSelect = styled(Box)(({ theme }) => ({

    marginTop : '12px',

    "& .MuiOutlinedInput-input": {
      color: theme.palette.grey[900],
      backgroundColor: '#f2f7fb',
      transition: 'all 0.4s ease-in-out',
      fontFamily: 'Roboto',
      borderRadius: '20px !important',
      fontSize: '17px',
      padding : '10px',
      '&:hover': {
        boxShadow: '0 0 25px #f2f7fb'
      },
  
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.grey[500],
      fontSize: '17px',
      borderRadius: '20px',
  
  
    },
    '& .MuiSvgIcon-root': {
      transition: 'all 0.7s ease-in-out'
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
      borderRadius: '20px',
      color: theme.palette.grey[500]
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
      borderRadius: '20px',
  
    },
  
  }))
  
  export {

    StyledSelect
  }